/*
 * Created with vue 2
 * Author: Cash/jaytanweb@163.com
 * Date: 08/03/2018
 * Time: 14:37
 */
<template>
  <div id='footer' class="footer">
    <div :class="{'active': type}">
      <div class="footer-box clearfix">
        <a href="javascript:;" class="btn-toggle" @click="btnToggle(type)"></a>
        <ul class="logo clearfix">
          <li class="kt"></li>
          <li class="alibaba"></li>
          <li class="tianxi"></li>
          <li class="bbg"></li>
        </ul>
        <div class="copyright">
          <ul class="link clearfix">
            <li><router-link to="/service">이용약관</router-link></li>
            <li><router-link to="/privace">개인정보취급방침</router-link></li>
            <li><router-link to="/policy">운영정책</router-link></li>
          </ul>
          <a href="mailto:cs_kr@bbgameonline.com" class="eamil">mail : cs_kr@bbgameonline.com</a>
          <p class="text">HONG KONG BLACK BEARD GAME LIMITED All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footers',
  data () {
    return {
      type: false
    }
  },
  components: {

  },
  methods: {
    btnToggle (type) {
      this.type = !type
      this.$lib.addC4M('footer', 'footer-mobile')
      this.$lib.addC4Mac('footer', 'footer-Mac')
      this.$lib.addC4iPad('footer', 'footer-iPad')
    }
  },
  mounted: function () {
    console.log('-- footer mounted --')
    this.$lib.addC4M('footer', 'footer-mobile')
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.footer {
  //begin you code
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color:#fff;
  &>div{
    height: 38px;
    overflow: hidden;
    transition: all .5s;
    background: rgba(0, 0, 0, .5);
    // background: #f00;
    &.active{
      background: rgba(0, 0, 0, 1);
      // background:#f00;
      height: 150px;
      .footer-box{
        padding-top: 14px;
        .btn-toggle{
          background: url(../assets/images/index/page3/bottom.png)no-repeat;
          background-size: contain;
        }
      }
    }
    .footer-box{
      width:859px;
      height:100%;
      // padding-top:14px;
      padding-top: 2px;
      margin: 0 auto;
      .btn-toggle{
        display:block;
        margin: 0 auto 16px;
        width: 60px;
        height: 30px;
        // transition: background .5s;
        background: url(../assets/images/index/page3/top.png)no-repeat;
        background-size: contain;
      }
      .logo{
        float:left;
        width:352px;
        // padding-top:0;
        margin-right:.29rem;
        height:100%;
        text-align:right;
        .kt{
          width: 92px;
          height: 58px;
          background: url(../assets/images/basicIcon/logo-kt.png)no-repeat;
          margin-right: 30px;
        }
        .alibaba{
          width: 60px;
          height: 60px;
          background: url(../assets/images/basicIcon/logo-alibaba.png)no-repeat;
          margin-right: 29px;
        }
        .tianxi{
          width: 58px;
          height: 58px;
          background: url(../assets/images/basicIcon/logo-tianxi.png)no-repeat center;
          margin-right: 25px;
        }
        .bbg{
          width:58px;
          height: 58px;
          background: url(../assets/images/basicIcon/logo-bbg.png)no-repeat center;
        }
        .kt,.alibaba,.bbg,.tianxi{
          float:left;
          background-size:100%;
        }
      }
      .copyright{
        float:left;
        width: 478px;
        // padding-top:0;
        height:100%;
        a,p{
          display:block;
          font-size:13px;
          color:#fff;
          transition:all .5s;
        }
        .link{
          height:18px;
          margin-bottom:11px;
          li{
            float:left;
            position:relative;
            padding-right:13px;
            line-height:14px;
            @media screen and (min-width:1024px) {
              &:hover a{
                color:#eed39d;
              }
            }
            &:nth-of-type(2),&:last-child{
              padding-left:13px;
            }
            &:not(:last-child){
              border-right:1px solid #fff;
            }
          }
        }
        .eamil{
          font-size:13px;
          height:16px;
          line-height:16px;
        }
        .text{
          margin-top:12px;
        }
      }
    }
  }
}
.footer-mobile {
  //begin you code
  color: #fff;
  &>div{
    height: .52rem;
    &.active{
      height: 1.63rem;
    }
    .footer-box {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding-top: .04rem;
      .btn-toggle{
        width: .6rem;
        height: .3rem;
        margin-bottom: .18rem;
      }
      .logo {
        float:none;
        width: 3.52rem;
        margin: 0 auto;
        height: .6rem;
        padding-top: 0;
        text-align: center;
        .kt {
          width: .92rem;
          height: .58rem;
          background: url(../assets/images/basicIcon/logo-kt.png) no-repeat;
        }
        .alibaba {
          width: .60rem;
          height: .60rem;
          background: url(../assets/images/basicIcon/logo-alibaba.png) no-repeat;
          margin-left: .26rem;
        }
        .tianxi{
          width: .58rem;
          height: .58rem;
          background: url(../assets/images/basicIcon/logo-tianxi.png) no-repeat;
          margin-left: .24rem;
        }
        .bbg {
          width: .58rem;
          height: .58rem;
          background: url(../assets/images/basicIcon/logo-bbg.png) no-repeat;
          margin-left: .2rem;
        }
        .kt, .alibaba, .bbg , .tianxi{
          // float: left;
          margin-right: 0;
          float:none;
          font-size: 0;
          display:inline-block;
          vertical-align: middle;
          background-size: contain;
        }
      }
      .copyright {
        width: 100%;
        padding-top: .16rem;
        margin: 0 auto;
        float: none;
        height: auto;
        text-align: center;
        a, p {
          display: block;
          font-size: .14rem;
          color: #fff;
          transition: all .5s;
        }
        .link {
          display: none;
        }
        .eamil {
          display: none;
        }
        .text {
          margin-top: 0;
        }
      }
    }
  }
}
.footer-iPad {

}
</style>



// WEBPACK FOOTER //
// src/components/footers.vue